import { render, staticRenderFns } from "./MerchantBalanceLogs.vue?vue&type=template&id=684a7d40&"
import script from "./MerchantBalanceLogs.vue?vue&type=script&lang=ts&"
export * from "./MerchantBalanceLogs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MerchantBalanceLogs.vue"
export default component.exports